export default {
    content: window.content || null,
    feature: window.feature,
    language: document.getElementsByTagName('html')[0].getAttribute('lang'),
    liheData: window.lihe || null,
    liheId: window.lihe.id,

    ssrReviewData: window.reviews,
    responseReviewData: window.reviews,

    reviewsArray: window.reviews.reviews,

    loading: false,

    currentCard: 0,
    animating: false,
    cardsDisplayed: 3,
    sliderCardWidth: null,
    ratingsToShow: null,

    viewDetailClicked: false,

    screenType: 'desktop',
}